export default __webpack_public_path__ + "static/media/header.00be9a0e.png";